import { useEffect, useRef } from "react";
import { productConfig } from "../config/product";
import { useSession } from "../state/SessionProvider";

/**
 * Leave / Quick Exit:
 * - Clears QuietVia in-memory session state
 * - Navigates to a bland external page via location.replace
 * Does NOT claim to erase browser history, DNS, Wi-Fi logs, screenshots, MDM, or forensics.
 * Does NOT perform unreliable history scrubbing tricks.
 */
export function ExitPage() {
  const { translate, clearSession } = useSession();
  const cleared = useRef(false);

  useEffect(() => {
    if (cleared.current) return;
    cleared.current = true;
    clearSession();
    window.location.replace(productConfig.quickExitUrl);
  }, [clearSession]);

  return (
    <section className="stack" aria-live="polite">
      <h1 tabIndex={-1}>{translate("page.exit.title")}</h1>
      <p className="muted">{translate("page.exit.disclaimer")}</p>
    </section>
  );
}
